import React, { useReducer, useEffect } from 'react'
import API from 'utils/API'
import addDays from 'date-fns/addDays'

const initNotificationState = () => ({
  totalUnreadNotif: 0,
  notifications: [],
  notifStatus: 'idle',
})

const notificationReducer = (state = initNotificationState(), action) => {
  switch (action.type) {
    case 'SET_NOTIFICATIONS':
      return {
        ...state,
        notifications: action.payload.notifications,
        totalUnreadNotif: action.payload.totalUnreadNotif,
        notifStatus: 'completed',
      }
    case 'SET_PENDING':
      return { ...state, notifStatus: 'pending' }
    default:
      return state
  }
}

const initialNotificationCtx = {
  state: initNotificationState(),
  dispatch: () => {},
}

const NotificationCtx = React.createContext(initialNotificationCtx)

const NotificationProvider = ({ children }) => {
  const [state, dispatch] = useReducer(notificationReducer, initNotificationState())

  const getUnread = (notifications) => {
    let unread = 0
    notifications.forEach((notif) => {
      if (notif.unread) {
        unread += 1
      }
    })
    return unread
  }

  const getNotif = async () => {
    const data = await API.get('/notifications')
    const notifications = data.data.notifications.map(notif => ({ ...notif, unread: true }))
    dispatch({
      type: 'SET_NOTIFICATIONS',
      payload: { notifications, totalUnreadNotif: notifications.length },
    })
    window.localStorage.setItem('notificationStartedAt', addDays(new Date(), 1).getTime().toString())
    window.localStorage.setItem('notifications', JSON.stringify(notifications))
  }

  useEffect(() => {
    const currentNotif = window.localStorage.getItem('notifications') || ''
    const currentNotifTime = window.localStorage.getItem('notificationStartedAt') || ''

    if (!currentNotif || parseInt(currentNotifTime, 10) < new Date().getTime()) {
      dispatch({ type: 'SET_PENDING' })
      getNotif()
    } else {
      const notifData = JSON.parse(currentNotif)
      dispatch({
        type: 'SET_NOTIFICATIONS',
        payload: { notifications: notifData, totalUnreadNotif: getUnread(notifData) },
      })
    }
  }, [])

  return <NotificationCtx.Provider value={{ state, dispatch }}>{children}</NotificationCtx.Provider>
}

export { NotificationCtx, NotificationProvider }
